// extracted by mini-css-extract-plugin
export var conversationListItem = "_yj-2";
export var fullBleedList = "_yj-3";
export var messageText = "_yj-1";
export var previewText = "_yj-0";